import { lazy } from 'react'

export const EditInstanceNameModalAsync = lazy(() => import('./EditInstanceNameModal')
    .then(module => ({ default: module.EditInstanceNameModal }))
)
